<div class="d-flex align-items-center">
    Su genero es:
    <ng-select class="ps-1 flex-grow-1" [items]="generos" bindValue="id" bindLabel="name" [(ngModel)]="condicion.data">
        <ng-template ng-option-tmp let-item="item">
            {{item.name}}
        </ng-template>
    </ng-select>
    <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarOperandoCmd.puedeEjecutarse"
        [command]="borrarOperandoCmd">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
